/*
 * THTD localizace — geolokační návrh (náhrada Orbe auto-redirectu).
 * Zjistí zemi návštěvníka přes Shopify /browsing_context_suggestions.json a pokud se liší
 * od aktuální (a je to nakonfigurovaný market), zobrazí plovoucí toast s nabídkou přepnutí
 * na místní měnu. „Zůstat" se uloží do localStorage, aby toast příště neotravoval.
 * Selektory země/jazyka jsou čistě nativní <select> (žádný JS zde netřeba).
 */
(function () {
  var toast = document.querySelector('[data-thtd-geo]');
  if (!toast) return;

  var KEY = 'thtd_geo_dismissed_v1';
  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  var current = (toast.getAttribute('data-current-country') || '').toUpperCase();
  var countryInput = toast.querySelector('[data-thtd-geo-country-input]');
  var countryLabel = toast.querySelector('[data-thtd-geo-country]');
  var currencyLabel = toast.querySelector('[data-thtd-geo-currency]');
  var dismissBtn = toast.querySelector('[data-thtd-geo-dismiss]');

  var map = {};
  var mapEl = document.querySelector('[data-thtd-geo-map]');
  if (mapEl) { try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) {} }

  function dismiss() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.setAttribute('hidden', ''); }, 300);
  }
  if (dismissBtn) dismissBtn.addEventListener('click', dismiss);

  fetch('/browsing_context_suggestions.json', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      var c = d && d.detected_values && d.detected_values.country;
      if (!c || !c.handle) return;
      var handle = c.handle.toUpperCase();
      if (handle === current) return;       // už jsme ve správné zemi
      var entry = map[handle];
      if (!entry) return;                   // detekovaná země není nakonfigurovaný market → neukazuj
      if (countryInput) countryInput.value = handle;
      if (countryLabel) countryLabel.textContent = entry.name || c.name || handle;
      if (currencyLabel) currencyLabel.textContent = entry.cur || '';
      toast.removeAttribute('hidden');
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    })
    .catch(function () {});
})();

/*
 * Lokalizační modal — vlajka v hlavičce (data-thtd-loc-open) otevře <dialog>.
 * Nativní <dialog>.showModal() = top-layer (fixní navbar ho neořízne) + ESC/focus zdarma.
 * Křížek i klik na backdrop zavírají; po zavření vrací fokus na trigger.
 * Přepíná se Save tlačítkem (jeden form, zemi i jazyk najednou); výběr země živě mění vlajku.
 */
(function () {
  var modal = document.querySelector('[data-thtd-loc-modal]');
  var openers = document.querySelectorAll('[data-thtd-loc-open]');
  if (!modal || !openers.length) return;

  var lastOpener = null;
  var downOnBackdrop = false;

  function refocus() {
    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
  }
  function open(opener) {
    lastOpener = opener || null;
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }
  function close() {
    if (typeof modal.close === 'function') { modal.close(); }   // 'close' event → refocus()
    else { modal.removeAttribute('open'); refocus(); }
  }

  for (var i = 0; i < openers.length; i++) {
    openers[i].addEventListener('click', function (e) { e.preventDefault(); open(e.currentTarget); });
  }
  var closeBtn = modal.querySelector('[data-thtd-loc-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // ESC i .close() vyvolají 'close' event → vrať fokus na trigger
  modal.addEventListener('close', refocus);

  // zavři jen když gesto ZAČALO i skončilo na backdropu (ne drag z obsahu ven).
  // .thtd-locm má padding 0, obsah je v __inner → e.target === modal jen na backdropu.
  modal.addEventListener('mousedown', function (e) { downOnBackdrop = (e.target === modal); });
  modal.addEventListener('click', function (e) {
    if (e.target === modal && downOnBackdrop) close();
  });

  // živý náhled: výběr země hned překlopí vlajku v modalu (commit až po Uložit + reloadu)
  var countrySel = modal.querySelector('[data-thtd-loc-country]');
  var flagWrap = modal.querySelector('[data-thtd-loc-flag]');
  if (countrySel && flagWrap) {
    countrySel.addEventListener('change', function () {
      var opt = countrySel.options[countrySel.selectedIndex];
      var url = opt && opt.getAttribute('data-flag');
      var img = flagWrap.querySelector('img');
      if (url && img) { img.src = url; img.style.visibility = 'visible'; }
    });
  }
})();
